export default __webpack_public_path__ + "static/media/brain.4e1c1f6a.png";